export default class Action {
  constructor(data, element, serialize) {
    for (const selector in data) {
      if (data.hasOwnProperty(selector)) {
        this.$selector = $(selector);
        if (selector === 'this') this.$selector = $(element);

        const { $selector } = this;
        const elementData = data[selector];

        if (elementData.class) $selector.toggleClass(elementData.class);
        if (elementData.removeClass) $selector.removeClass(elementData.removeClass);
        if (elementData.addClass) $selector.addClass(elementData.addClass);
        if (elementData.click === true) $selector.click();
        if (elementData.submit === true) $selector.submit();
        if (elementData.text) $selector.text(elementData.text);
        if (elementData.html) $selector.html(elementData.html);
        if (elementData.htmlSelector) $selector.html('').html($(elementData.htmlSelector).clone());
        if (elementData.hasOwnProperty('val')) $selector.val(elementData.val);
        if (elementData.remove) $selector.remove();
        if (elementData.removeAttr) $selector.removeAttr(elementData.removeAttr);
        if (elementData.attr) $selector.attr(elementData.attr);
        if (elementData.hide) $selector.hide();
        if (elementData.show) $selector.show();
        if (elementData.submit) $selector.submit();
        if (elementData.prop) $selector.prop(elementData.prop);
        if (elementData.siblings) {
          if (elementData.siblings.class) $selector.toggleClass(elementData.siblings.class).siblings().toggleClass(elementData.siblings.class);
          if (elementData.siblings.addClass) $selector.addClass(elementData.siblings.addClass).siblings().removeClass(elementData.siblings.addClass);
          if (elementData.siblings.removeClass) $selector.removeClass(elementData.siblings.removeClass).siblings().addClass(elementData.siblings.removeClass);
        }
        if (elementData.toggle) this.actionsToggle(elementData.toggle);
        if (elementData.scroll) this.actionsScroll(elementData.scroll);
        if (elementData.xhr) this.actionsXhr(elementData.xhr, element, serialize);
        if (elementData.ajax) this.actionsAjax(elementData.ajax, element, serialize);
        if (elementData.enabled) $selector.removeAttr('disabled').prop('disabled', false);
        if (elementData.disabled) $selector.attr('disabled').prop('disabled', true);
        if (elementData.modalAjax) this.modalAjax($selector, elementData.modal, element, serialize);
      }
    }
  }

  actionsToggle(toggle) {
    switch (toggle) {
      case 'slide':
        this.$selector.slideToggle('fast');
        break;
      case 'slideUp':
        this.$selector.slideUp('fast');
        break;
      case 'slideDown':
        this.$selector.slideDown('fast');
        break;
      case 'fade':
        this.$selector.fadeToggle('fast');
        break;
      case 'fadeIn':
        this.$selector.fadeIn('fast');
        break;
      case 'fadeOut':
        this.$selector.fadeOut('fast');
        break;
    }
  }

  actionsScroll(int) {
    const offset = this.$selector.offset().top + int;
    $('html, body').animate({ scrollTop: offset }, 'fast');
  }

  actionsAjax(data, element, serialize) {
    let url;
    url = (data.url ? data.url : $(element).attr('href'));
    if (serialize) url = `${url}?${serialize}`;

    $.ajax({
      url,
      cache: false,
      type: (data.type ? data.type : 'GET'),
      data: data.data ? data.data : { isNaked: 1 },
      success(response) {
        if (data.response) response = $(response).find(data.response);

        if (data.selector === 'this') {
          this.$selector.html(response);
          if (data.addClass) this.$selector.find('.component').addClass(data.addClass);
        } else {
          if ($(data.selector).length) $(data.selector).html(response);
          if (data.addClass) $(data.selector).find('.component').addClass(data.addClass);
        }

        // Изменить адсресную строку
        if (data.history) history.pushState(null, null, url);
      },
    });
  }

  actionsXhr(ajax, element, serialize) {
    const xhr = new XMLHttpRequest();
    let url;

    url = (ajax.url ? ajax.url : $(element).attr('href'));
    if (serialize) url = `${url}?${serialize}`;
    const type = (ajax.type ? ajax.type : 'GET');

    xhr.open(type, url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          if (xhr.responseText.trim().length) {
            // let response = $(xhr.responseText);
          }
        }
      }
    };
  }

  modalAjax($selector, data, element, serialize) {
    if (typeof data === 'object') {
      $selector.addClass('--active');
      if (data.ajax) {
        data.ajax.selector = this.actionsAjax(data.ajax, element, serialize);
      }
    }
  }

  init() {
    const $body = $('body');

    // Клик
    $body.on('click', '[data-click]', function () {
      const data = $(this).data('click');

      new Action(data, this);
      if ($(this).is('a')) return false;
      return true;
    });
  }

  render() {
    this.init();

    return this;
  }
}
